import connectEntity from './helpers/connect-entity'
import ImgixImg from './imgix-img'

import { path } from '../utils/obj'

export default connectEntity((_state, { description, file, ...props }) => ({
  alt: description,
  src: path(['url'], file),
  ...props,
}))(ImgixImg)
